/* @flow */
import * as React from 'react';
import { css } from 'linaria';
import { renderRoutes, matchRoutes } from 'react-router-config';

import AspectRatio from '../../components/AspectRatio';
import Colors from '../../constants/Colors';
import { Page, PageHelmet } from '../../components/chrome';
import Hero from '../../components/Hero';
// import MediaQueries from '../../constants/MediaQueries';
import ServicesPageChromeFooterNav from './components/ServicesPageChromeFooterNav';
import { Container, Illustration, SectionTitle, Spacer } from '../../components/core';
import type { IllustrationID } from '../../components/core/Illustration';
import type { ServicesPageChromeFooterNavTabId } from './components/ServicesPageChromeFooterNav';

export type ServicesPageChromeMetadata = {
  illustration: IllustrationID,
  id: ServicesPageChromeFooterNavTabId,
};

function ServicesPageChrome({
  route,
  location,
}: {
  route: {
    routes: {},
  },
  location: {
    pathname: String,
  },
}) {
  let branch = matchRoutes(route.routes, location.pathname);
  let activeRoute = branch[0].route;
  let BodyComponent = activeRoute.component;
  let metadata: ServicesPageChromeMetadata = BodyComponent.servicesMetadata;

  return (
    <Page headerTheme="light">
      <PageHelmet page={BodyComponent} />
      <Hero backgroundColor={Colors.GrayLight}>
        <AspectRatio maxHeight={350}>
          <Container padded={true} align="center" className={Styles.IllustrationContainer}>
            <Illustration name={metadata.illustration} style={{ minWidth: 600 }} />
          </Container>
        </AspectRatio>
      </Hero>
      {renderRoutes(route.routes)}
      <Container size="large" padded={true}>
        <Spacer size={0} color={Colors.Divider} />
      </Container>
      <Container padded={true}>
        <Spacer size={100} />
        <SectionTitle title="Other ways to use us" />
        <Spacer size={60} />
        <ServicesPageChromeFooterNav selectedTab={metadata.id} />
        <Spacer size={120} />
      </Container>
    </Page>
  );
}

const Styles = {
  IllustrationContainer: css`
    display: flex;
    align-items: flex-end;
    height: 100%;
  `,
};

export default ServicesPageChrome;



// WEBPACK FOOTER //
// ./src/ui/pages/ServicesPage/ServicesPageChrome.js